import { render, staticRenderFns } from "./addProblemClassification.vue?vue&type=template&id=59fe0ac4&"
import script from "./addProblemClassification.vue?vue&type=script&lang=js&"
export * from "./addProblemClassification.vue?vue&type=script&lang=js&"
import style0 from "./addProblemClassification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports